import { ref, push, set, remove, onValue, off } from 'firebase/database';
import { database } from '../firebase/config';
import { useAuth } from './useAuth';
import { useDispatch } from 'react-redux';
import { setSummary } from './summarySlice';


export const useDatabase = () => {

    const { uid } = useAuth();
    const dispatch = useDispatch();

    const saveUserSummary = async ( transcript ) => {
        const summaryRef = ref(database, `summary/${uid}`);
        const uploadSummaryRef = push(summaryRef);
        const data = {
            id: uploadSummaryRef.key,
            transcript: transcript,
            createdAt: Date.now()
        }
        await set(uploadSummaryRef, data);
        return data;
    }

    const fetchUserSummary = async () => {
        const summaryRef = ref(database, `summary/${uid}`);
        return new Promise((resolve) => {
            onValue(summaryRef, (snapshot) => {
              const data = snapshot.val();
              const summaries = data ? Object.values(data) : [];
              dispatch(setSummary(summaries));
              resolve(summaries);
            });
        });
    }

    return {
        saveUserSummary,
        fetchUserSummary
    }
};